import { useQuery } from "@tanstack/react-query";
import { EcommerceShoppingCartClient } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import ms from "ms";

export const RECOMMENDED_ADDONS_QUERY_KEY = "recommendedAddOns";

/**
 * Fetches recommended add-ons (accessories + warranties) for a product (SPU-532
 * endpoint), used by the add-to-cart modal upsell (SPU-535). Accessories are returned
 * for all hardware; warranties only for config-system products. Enabled once the modal
 * has a product descriptor/class.
 */
export default function useGetRecommendedAddOns(
  productDescriptor: string | null | undefined,
  productClass: string | null | undefined,
  enabled: boolean,
) {
  const api = useApi(EcommerceShoppingCartClient);

  return useQuery({
    queryKey: [RECOMMENDED_ADDONS_QUERY_KEY, productDescriptor, productClass],
    queryFn: () =>
      api.getRecommendedAddOns(productDescriptor!, productClass!),
    enabled: enabled && !!productDescriptor && !!productClass,
    staleTime: ms("5m"),
  });
}
